<template>
    <component :is="template">
        <v-responsive width="100%" height="auto" max-width="420" class="mx-auto py-40px py-md-60px">
            <v-card elevation="0">
                <div class="pa-12px py-md-20px">
                    <v-row no-gutters align="center" class="text-center">
                        <v-col cols="12">
                            <h2 class="tit tit--sm">로그인</h2>
                        </v-col>
                        <v-col cols="12">
                            <span class="font-size-14 grey--text">대한문고의 다양한 서비스와 혜택을 누리세요</span>
                        </v-col>
                    </v-row>
                </div>
                <v-divider />

                <div class="pa-12px pa-md-20px">
                    <v-row class="row--x-small">
                        <v-col cols="12">
                            <v-text-field v-model="username" placeholder="아이디" outlined persistent-placeholder hide-details />
                        </v-col>
                        <v-col cols="12">
                            <v-password-field v-model="password" placeholder="비밀번호" outlined persistent-placeholder hide-details @keydown.enter="login" autocomplete="new-password" />
                        </v-col>
                    </v-row>
                    <v-row class="row--x-small">
                        <v-col cols="12">
                            <v-btn x-large block color="primary" @click="login">로그인</v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-btn x-large block outlined color="grey" to="/join"><span class="grey--text text--darken-3">회원가입</span></v-btn>
                        </v-col>
                    </v-row>
                </div>

                <v-divider />
                <div class="pa-12px px-md-20px">
                    <v-row no-gutters align="center">
                        <v-col cols="auto">
                            <v-checkbox v-model="isRemember" type="checkbox" label="아이디 저장" hide-details class="ma-0 font-size-14"></v-checkbox>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-btn small text color="grey darken-1" to="/idpw" class="font-weight-regular mr-n12px">아이디/비밀번호 찾기</v-btn>
                        </v-col>
                    </v-row>
                    <!-- <v-checkbox v-model="isRemember" hide-details class="mt-0 pa-0"/> -->
                    <!-- <label class="check check-light">
                        <input v-model="isRemember" class="input" type="checkbox" :value="true"/>
                        <i class="icon"></i>
                        <v-btn text tile>아이디 저장</v-btn>
                    </label> -->
                </div>
            </v-card>
        </v-responsive>
        <auto-block-dialog v-bind="{ username }" ref="auto-block-dialog" />
        <login-failed-count-dialog v-bind="{ username }" ref="login-failed-count-dialog" />
    </component>
</template>
<script>
import AutoBlockDialog from "@/components/client/login/auto-block-dialog.vue";
import LoginFailedCountDialog from "@/components/client/login/login-failed-count-dialog.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";

export default {
    components: {
        AutoBlockDialog,
        LoginFailedCountDialog,
        VPasswordField,
    },
    data() {
        return {
            username: this.$cookies.get("username") || null,
            password: null,

            isRemember: false,
            to: this.$route.query.to || null,

            // 사이트 안에서 이 화면으로 들어왔는지. 앱을 로그인 화면에서 바로 열면 돌아갈 화면이 없어
            // go(-1) 이 아무것도 하지 않는다(아이폰 홈 화면 앱에서 로그인 뒤 화면이 그대로 멈춰 보였음)
            hasPrevious: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.hasPrevious = from.matched.length > 0;
        });
    },
    methods: {
        validate() {
            try {
                if (!this.username) throw new Error("아이디를 입력해주세요");
                if (!this.password) throw new Error("비밀번호를 등록해주세요");
                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async login() {
            try {
                if (this.validate()) {
                    await this.$store.dispatch("login", {
                        username: this.username,
                        password: this.password,
                    });

                    if (this.isRemember) this.$cookies.set("username", this.username);

                    if (this.to) this.$router.replace(decodeURIComponent(this.to));
                    else if (this.hasPrevious) this.$router.go(-1);
                    else this.$router.replace("/");
                }
            } catch (error) {
                switch (error?.response?.data?.message) {
                    case "isAutoBlock": {
                        this.$refs?.["auto-block-dialog"].open?.();
                        break;
                    }
                    case "loginFailedCount": {
                        this.$refs?.["login-failed-count-dialog"].open?.();
                        break;
                    }
                    default: {
                        alert(error?.response?.data?.message ?? error.message);
                        break;
                    }
                }
            }
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.login}`);
        },
    },
};
</script>

<style scoped></style>
